import React from "react";
import {
  Box,
  FormControl,
  MenuItem,
  Pagination,
  Select,
  Typography,
} from "@mui/material";

export interface PaginationControlsProps {
  page: number;
  totalPages: number;
  rowsPerPage: number;
  rangeLabel: string;
  rowsPerPageOptions?: number[];
  onPageChange: (_: React.ChangeEvent<unknown>, value: number) => void;
  onRowsPerPageChange: (value: number) => void;
}

/**
 * Controles de paginação para listas no cliente (auditoria e modais).
 * Exibe seletor de linhas por página à esquerda e navegação de páginas à direita.
 */
export function PaginationControls({
  page,
  totalPages,
  rowsPerPage,
  rangeLabel,
  rowsPerPageOptions = [5, 10, 25, 50],
  onPageChange,
  onRowsPerPageChange,
}: PaginationControlsProps) {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      mt={2}
      flexWrap="wrap"
      gap={2}
    >
      <Box display="flex" alignItems="center" gap={1}>
        <Typography variant="body2" color="textSecondary">
          Linhas por página
        </Typography>
        <FormControl size="small" sx={{ minWidth: 70 }}>
          <Select
            value={rowsPerPage}
            onChange={(e) => onRowsPerPageChange(Number(e.target.value))}
          >
            {rowsPerPageOptions.map((opt) => (
              <MenuItem key={opt} value={opt}>
                {opt}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Box display="flex" alignItems="center" gap={2}>
        <Typography variant="body2" color="textSecondary">
          {rangeLabel}
        </Typography>
        <Pagination
          count={totalPages}
          page={page}
          onChange={onPageChange}
          color="primary"
          size="small"
          showFirstButton
          showLastButton
        />
      </Box>
    </Box>
  );
}

export default PaginationControls;
